"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InchcapeSelectorEvents = void 0;
/**
 * Events fired by the widget.
 */
var InchcapeSelectorEvents;
(function (InchcapeSelectorEvents) {
    InchcapeSelectorEvents["SAVE_PROGRESS"] = "save progress";
    InchcapeSelectorEvents["CLOSE_FINISHED"] = "close:finished";
    InchcapeSelectorEvents["CLOSE_EXCEPTION"] = "close:exception";
    InchcapeSelectorEvents["RESTARTED"] = "restarted";
    InchcapeSelectorEvents["CREATE_VALUATION"] = "valuation:create";
    InchcapeSelectorEvents["COMPLETED_VALUATION"] = "valuation:completed";
    InchcapeSelectorEvents["BLOCKED_VALUATION"] = "valuation:blocked";
    InchcapeSelectorEvents["UPDATE_VALUATION"] = "valuation:update";
})(InchcapeSelectorEvents = exports.InchcapeSelectorEvents || (exports.InchcapeSelectorEvents = {}));
